import * as React from 'react'

export default function useCombinedRefs<T = any>(
  ...refs: (
    | React.RefObject<T>
    | React.MutableRefObject<T | null>
    | ((instance: T | null) => void)
    | null
    | undefined
  )[]
) {
  const targetRef = React.useRef<T>(null)

  React.useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return

      if (typeof ref === 'function') {
        ref(targetRef.current)
      } else {
        ref.current = targetRef.current
      }
    })
  }, [refs])

  return targetRef
}
